/**
 * Created by jv on 08/05/2017.
 */
//js
const log = require("Sources/utils/logger")();
import Shared from "Sources/shared";
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import LoginManager from "Sources/services/login-manager";
import StorageController from "Sources/controllers/storage-controller";
import FormValidator from "Sources/components/form-validator";

//Styles
require("Styles/pages/login.scss");

$(function () {
  Shared.init();
  LoginPage.init();
});

let LoginPage = {};

((LoginPage) => {
  let $usernameForm,
    $loginForm;

  let emailFormValidator = null;
  let loginFormValidator = null;

  LoginPage.init = function () {
    setUpEventListeners();
    setUpLoginForm();

    $("#page-title").text(LanguageManager.getValueForKey("login.page_title"));

    $usernameForm = $("#login-form1");
    $loginForm = $("#login-form2");
  };

  function setUpEventListeners() {
    $("#validate-email-btn").off("click").on("click", (e) => {
      validateUsername();
    });

    $("#authenticate-btn").on("click", function (e) {
      let $this = $(this);
      let isValid = loginFormValidator.validate();

      if (isValid) {
        $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");

        login().finally(() => {
          $this.prop("disabled", false).removeClass("btn-loading");
        });
      }
    });

    let $usernameInput = $("#login-username-input");

    $usernameInput.off("input").on("input", function (e) {
      $(this).removeClass("input-error");
    });

    let $passwordInput = $("#login-password-input");

    $passwordInput.off("input").on("input", function (e) {
      $(this).removeClass("input-error");
    });

    $passwordInput.off("keyup").on("keyup", function (e) {
      if ((utils.isNotNull(e.code) && e.code === "Enter") || e.keyCode === 13) {
        $(this).blur();
        login();
      }
    });

    $("#login-username1-input").off("keypress").on("keypress", (e) => {
      if ((utils.isNotNull(e.code) && e.code === "Enter") || e.keyCode === 13) {
        $(this).blur();
        validateUsername();
      }
    });

    $("form").off("keypress").on("keypress", function (e) {
      if ((utils.isNotNull(e.code) && e.code === "Enter") || e.keyCode === 13) {
        e.preventDefault();
      }
    });
  }

  function setUpLoginForm() {
    emailFormValidator = new FormValidator({
      selector: "#login-form1",
      validateOnChange: true,
      rules: {
        username: {
          validator: (username) => {
            return !utils.isNullOrEmpty(username) && username.trim() !== "";
          }
        }
      }
    });

    loginFormValidator = new FormValidator({
      selector: "#login-form2",
      validateOnChange: true,
      rules: {
        password: {
          validator: (password) => {
            return !utils.isNullOrEmpty(password) && password.trim() !== "";
          }
        }
      }
    });
  }

  function validateUsername() {
    let isValid = emailFormValidator.validate();

    if (isValid) {
      let formData = emailFormValidator.getFormData();
      let username = formData.username;

      let $validateEmailBtn = $("#validate-email-btn");

      $validateEmailBtn.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");

      let $formFeedback = $usernameForm.find(".form-feedback").empty();

      return LoginManager.usernameExists(username)
        .then(data => {
          log.info("Username [%s] exists ? %o", username, data);

          emailFormValidator.setValid("username", data.data);

          if (data.data) {
            loginFormValidator.setValueForKey("username", username);

            $usernameForm.removeClass("form-active");
            $loginForm.addClass("form-active");

            setTimeout(() => $("#login-password-input").focus(), 300);
          } else {
            // Username doesn't exist
            $formFeedback.text(LanguageManager.getValueForKey("login.errors.username_not_found"));
            $("#login-username1-input").focus();
          }
        })
        .catch(err => {
          log.error("Failed to check if username [%s] exists - %o", username, err);
        })
        .finally(() => {
          $validateEmailBtn.prop("disabled", false).removeClass("btn-loading");
        });
    }
  }

  function login() {
    if (utils.isNull(loginFormValidator)) return;

    let $formFeedback = $loginForm.find(".form-feedback").empty();

    let formData = loginFormValidator.getFormData();

    let username = formData.username,
      password = formData.password;

    return LoginManager.login(username, password)
      .then((data) => {
        let loginData = data.loginData,
          referer = data.referer;

        StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, loginData);

        log.info("Referer: %s", referer);

        if (!utils.isNullOrEmpty(referer) && referer.includes("/login")) {
          utils.redirect("/teacher/platform");
        } else {
          utils.redirect(referer);
        }
      })
      .catch((appError) => {
        log.error("Login failed - %o", appError);

        loginFormValidator.setValid("password", false);
        $("#login-password-input").focus();

        if (appError.data.errorType === LoginManager.ERRORS.USERNAME_PASSWORD_INCORRECT) {
          $formFeedback.text(LanguageManager.getValueForKey("login.errors.password_incorrect"));
        } else {
          $formFeedback.text(LanguageManager.getValueForKey("login.errors.unexpected"));
        }
      });
  }
})(LoginPage);



// WEBPACK FOOTER //
// ./app/js/entries/login.js